export const sanitize = val => val.replace(/[\[\]"']+/g, '');
